import dayjs from "dayjs";
import { convertAndGetTimeStampInRequiredFormat } from "../../../Helper/DatePicker/DateConverter";
import { isOrganizationJBM } from "../../../Helper/Organization/Functions";
import { ANNOTATION_SOURCE } from "./CommonFunctions";

/**
 * Build the (pre-encryption) route params for opening Advanced Analytics from a
 * faults/alerts listing row. Shared by BMS Faults and Smart Alerts entry points
 * so both produce an identical param shape.
 *
 * The date window spans the incident's trigger time to its resolution time
 * (or today when still active). `eventsSource` tells Advanced Analytics which
 * Events root (bmsfaults / smartalerts) to resolve the auto-loaded events under.
 *
 * @param {object} args
 * @param {object} args.battery         — { batteryID, deviceID, licensePlateNo }
 * @param {object} args.alertIncident   — normalized incident (BMS-fault field names)
 * @param {string} [args.source]        — ANNOTATION_SOURCE value
 * @returns {object} params object to pass to encryptTheParams
 */
export const buildAdvancedAnalysisParams = ({ battery, alertIncident, source = ANNOTATION_SOURCE.BMS_FAULT }) => {
    const events = alertIncident?.incidentErrorName ? [alertIncident.incidentErrorName] : [];

    const startDate = alertIncident?.customerDBTimeInsert
        ? convertAndGetTimeStampInRequiredFormat(alertIncident.customerDBTimeInsert, "YYYY-MM-DD")
        : null;

    const endDate = alertIncident?.resolveCustomerDBTime
        ? convertAndGetTimeStampInRequiredFormat(alertIncident.resolveCustomerDBTime, "YYYY-MM-DD")
        : dayjs().format("YYYY-MM-DD");

    let params = {
        batteryID: battery?.batteryID,
        deviceID: battery?.deviceID,
        selectedType: 'deviceID',
        selectedTypeId: battery?.deviceID,
        events: JSON.stringify(events),
        startDate,
        endDate,
        entityAffectedType: alertIncident?.entityAffected || 'battery',
        entityAffectedId: alertIncident?.entityAffectedID,
        alertMetaID: alertIncident?.alertMetaID ?? null,
        category: alertIncident?.category || null,
        eventsSource: source,
    };

    if (isOrganizationJBM() && battery?.licensePlateNo) {
        params = {
            ...params,
            selectedType: 'vehicle',
            selectedTypeId: battery.licensePlateNo,
        };
    }

    return params;
};
